import budget from './budget/'
import budgetTool from './budgetTool'
import dealer from './dealer'
import dealerOverview from './dealer-overview'
import dom from './dom'
import drillDown from './drillDown'
import enterpriseReporting from './enterprise-reporting'
import expense from './expense'
import expenseModal from './expenseModal'
import marketShare from './market-share/'
import planner from './planner/'
import reportBuilderReport from './reportBuilderReport'
import sales from './sales'
import trends from './trends'
import twofactor from './twofactor'
import user from './user'

export default {
  user,
  drillDown,
  budget,
  marketShare,
  dom,
  trends,
  expenseModal,
  dealer,
  budgetTool,
  expense,
  planner,
  sales,
  enterpriseReporting,
  twofactor,
  dealerOverview,
  reportBuilderReport,
}
